import {GetterTree} from 'vuex'
import {StatisticState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    mailNotifyStaticDetail: state => state.mailNotifyStaticDetail,
    mailNotifyStaticDetailFlag: state => state.mailNotifyStaticDetailFlag,
    mailNotifyStatisticGroup: state => state.mailNotifyStatisticGroup,
    mailNotifyGroupBy: state => state.mailNotifyGroupBy,
    mailNotifyGroupByOptionally: state => state.mailNotifyGroupByOptionally,
};
